module.exports = __webpack_public_path__ + "img/wallet-three.0934366e.svg";